module.exports = __webpack_public_path__ + "img/dl-ios.7b1c5e2b.svg";